import React from "react";

export default function WidgetContainer(props) {
    
    return (
        <div id="xs-live-tracker" {...props}>
            {props.children}
        </div>
    );
}